<template functional>
    <button
        :ref="data.ref"
        v-tooltip
        class="btn"
        :type="props.type"
        :class="[data.staticClass, data.class, props.color, props.isSmall ? 'btn-sm' : null]"
        :title="props.title || props.label"
        :disabled="props.disabled || props.isLoading"
        v-bind="data.attrs"
        v-on="listeners">
        <i v-if="props.iconClass" class="fa-fw" :class="props.isLoading ? 'fa fa-spin fa-spinner' : props.iconClass" />
        <span v-if="!props.hideLabel" class="btn-label">
            <template v-if="props.isLoading">{{ parent.$t('common.actions.wait') }}</template>
            <template v-else>{{ props.label }}</template>
        </span>
    </button>
</template>

<script>
export default {
    name: 'BaseButton',

    functional: true,

    props: {
        label: {type: String, default: null},
        iconClass: {type: String, default: null},
        color: {type: String, default: null},
        title: {type: String, default: null},
        isSmall: {type: Boolean},
        hideLabel: {type: Boolean},
        isLoading: {type: Boolean},
        disabled: {type: Boolean},
        type: {
            type: String,
            default: 'button',
            validator: (value) => ['button', 'submit'].indexOf(value) !== -1,
        },
    },
};
</script>
